(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["address-pick-modal"]) return;
  try {
    
//<script> // For highlighting
  var callback;
  function confirmAddressModal(fields, type, cb) {
    var box;
    if (type === 'InteractionRequired' || type === 'None') {
      box = $('#confirm-address-modal');
      box.find('.address-modal-text').html(normalizeSmartyStreetFieldsToString(fields));
      box.find('.address-confirm-button').click(function(e) {
        e.preventDefault();
        box.modal('hide')
        cb(fields.address);
      });
      box.find('.modal-title').text(type === 'InteractionRequired' ? 'Is this your correct address?' : 'We could not verify this address. Please make sure it is correct before continuing.');
      box.find('.address-cancel-button').click(function(e) {
        e.preventDefault();
        box.modal('hide')
        cb(null);
      });
      box.modal('show');
    } else if (type === 'Multiple') {
      box = $('#choose-address-modal');
      fields.results.forEach(function(choice, ind) {
        var button = $('<button class="full btn btn-block btn-outline-dark">');
        button.html(normalizeSmartyStreetFieldsToString(choice));
        $('.choose-address-modal-body').append(button);
        button.click(function(e) {
          e.preventDefault();
          box.modal('hide');
          cb(choice.address);
        });
      });
      box.modal('show');
    } else cb(new Error('Unhandled type ' + type));
  }


  function normalizeSmartyStreetFieldsToString(fields) {
    var address1 = fields.address.address1 || fields.address.street1;
    var address2 = fields.address.address2 || fields.address.street2 || '';
    var addressLine2 = (address2 !== '') ? '<br>' + address2 : address2;
    return '<p>' + address1  + addressLine2 + '</p><p>' + fields.lastLine + '</p>';
  };

  window.confirmAddressModal = confirmAddressModal;
  $(function() {
    $('.confirm-address-modal').appendTo('body');
    $('.choose-address-modal').appendTo('body');
  });
//</script>

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ifit-image-modal"]) return;
  try {
    
//<script> // For highlighting
  function showModalMesage(url) {
    var box = $('.ifit-modal-image-box');
    box.find('.ifit-modal-image-backdrop').scrollTop(0);
    box.find('.ifit-modal-image').attr('src', url);
    box.removeClass('ifit-hidden-image');
    $('body').addClass('noscroll');
  }

  window.iFitShowImageModalMessage = showModalMesage;
  $(function() {
    $('.ifit-modal-image-box').appendTo('body');
    $('.ifit-modal-image-popup,.ifit-modal-image-backdrop').click(function(e) {
      e.preventDefault();
      $('.ifit-modal-image-box').addClass('ifit-hidden-image');
      $('body').removeClass('noscroll');
    });
  });
  //</script>

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ifit-modal"]) return;
  try {
    
//<script> // For highlighting
  var callback;
  function showModalMesage(title, message, buttonText, cb) {
    if (cb) {
      if (callback) {
        callback('replaced');
      }
      callback = function(status) {
        callback = null;
        cb(status);
      };
    }
    var box = $('.ifit-modal-box');
    var showTitle = Boolean(title);
    box.find('.ifit-modal-title').text(title).toggle(showTitle);
    box.find('.ifit-modal-rule').toggle(showTitle);
    box.find('.ifit-modal-text-margin').toggle(!showTitle);
    box.find('.ifit-modal-text').text(message);
    box.removeClass('ifit-hidden-modal');
    if (buttonText === undefined) {
      buttonText = 'OK';
    }
    if (buttonText === null) {
      box.find('button').hide();
      box.find('.ifit-modal-close').show();
    } else {
      box.find('button').text(buttonText).show();
      box.find('.ifit-modal-close').hide();
    }
    $('body').addClass('noscroll');
  }

  window.iFitShowModalMessage = showModalMesage;
  $(function() {
    $('.ifit-modal-box').appendTo('body');
    $('.ifit-modal-popup .ifit-modal-close,.ifit-modal-popup .ifit-modal-button,.ifit-modal-backdrop').click(function(e) {
      e.preventDefault();
      $('.ifit-modal-box').addClass('ifit-hidden-modal');
      $('body').removeClass('noscroll');
      var className = e.target.className.split(/\s+/).filter(function(name) {
        return /^ifit-modal-/.test(name);
      })[0];
      var action = {
        'ifit-modal-close': 'closed',
        'ifit-modal-button': 'button clicked',
        'ifit-modal-backdrop': 'backdrop clicked'
      }[className] || 'unknown';
      if (callback) callback(action);
    });
  });
//</script>

  } catch(e) { console.error(e); }
})();

})();
